/**
 * Edit component
 */
import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	RichText,
	InspectorControls,
} from '@wordpress/block-editor';
import { PanelBody, TextControl } from '@wordpress/components';

export default function Edit( { attributes, setAttributes } ) {
	const { text } = attributes;
	const blockProps = useBlockProps( {
		className: 'nemtly-booking-trigger-wrapper',
	} );

	return (
		<>
			<InspectorControls>
				<PanelBody title={ __( 'Settings', 'nemtly-booking' ) }>
					<TextControl
						label={ __( 'Button Text', 'nemtly-booking' ) }
						value={ text }
						onChange={ ( value ) =>
							setAttributes( { text: value } )
						}
					/>
				</PanelBody>
			</InspectorControls>
			<div { ...blockProps }>
				<button className="nemtly-booking-trigger-btn nb-px-6 nb-py-2 nb-bg-blue-600 nb-text-white nb-rounded-lg">
					<RichText
						tagName="span"
						value={ text }
						onChange={ ( value ) =>
							setAttributes( { text: value } )
						}
						placeholder={ __( 'Book Now', 'nemtly-booking' ) }
						allowedFormats={ [] }
					/>
				</button>
			</div>
		</>
	);
}
